<template>
        <div class="body-content-overlay"></div>
        <div class="email-app-list">
            <div class="app-action">
                <div class="action-right">
                    <ul class="list-inline m-0">
                        <li class="list-inline-item">
                            <span @click="exportEmails" class="action-icon">
                                <i data-feather="download" class="font-medium-2"></i>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="email-user-list" >
                <ul class="email-media-list" v-if="clicksendStore.emailHistoryList && clicksendStore.emailHistoryList.data && clicksendStore.emailHistoryList.data.length > 0">
                    <li
                        class="media"
                        v-for="(email_data, index) in this.clicksendStore.emailHistoryList.data"
                        @click="showDetailedEmail(index)"
                        :class="{ 'mail-read': (index % 2 == 0) }"
                        v-for-callback="{ index:index, length: this.clicksendStore.emailHistoryList.data.length }"
                    >
                        <div class="media-left pr-50">
                            <div class="avatar">
                                <img :src="baseUrl + '/images/logo/logo1.jpg'" alt="avatar img holder" />
                            </div>
                        </div>
                        <div class="media-body">
                            <div class="mail-details mb-0">
                                <div class="mail-items">
                                    <h5 class="mb-25">
                                        <span class="text-primary">
                                            To:
                                        </span>
                                        {{ email_data.to[0].email }}
                                    </h5>
                                    <span class="text-truncate">
                                        <span class="text-primary">
                                            Subject:
                                        </span>
                                        {{ email_data.subject }}
                                    </span>
                                </div>
                                <div class="mail-meta-item">
                                    <span class="mr-50 badge badge-pill badge-light-primary">
                                        {{ email_data.status }}
                                    </span>
                                    <span class="mail-date">
                                        {{ moment.unix(email_data.date_added).format('lll') }}
                                    </span>
                                </div>
                            </div>
                            <div class="mail-message">
                                <p class="text-truncate mb-0">
                                    <span class="text-primary">
                                        Message:
                                    </span>
                                    {{ email_data.body_plain_text }}
                                </p>
                                <p v-if="email_data.letter && email_data.letter.lettername" class="text-truncate mb-0">
                                    <span class="text-primary">
                                        Letter Name:
                                    </span>
                                    {{ email_data.letter.lettername }}
                                </p>
                                <p v-if="email_data.letter" class="text-truncate mb-0">
                                    <span class="text-primary">
                                        Creditor Name:
                                    </span>
                                    {{ email_data.letter.credit_bureau_name }}
                                </p>
                            </div>
                        </div>
                    </li>
                    <button
                        class="btn btn-light text-primary col-12"
                        v-if="clicksendStore.emailHistoryList.next_page_url != null"
                        @click="clicksendStore.fetchEmailHistory(clicksendStore.emailHistoryList.next_page_url)"
                    >
                        Load More
                    </button>
                </ul>
                <div class="no-results" v-else>
                    <h5>No Items Found</h5>
                </div>
            </div>
        </div>
        <div v-if="activeEmailID != null" class="email-app-details" :class="{ 'show' : showDetail }">
            <div class="email-detail-header">
                <div class="email-header-left d-flex align-items-center">
                    <span class="go-back mr-1" @click="showDetail = false">
                        <vue-feather type="chevron-left" size="1.4rem"></vue-feather>
                    </span>
                    <h4 class="email-subject mb-0">
                        <span class="text-primary">
                            Subject:
                        </span>
                        {{ getActiveEmail.subject }}
                    </h4>
                </div>
            </div>
            <div class="email-scroll-area mt-50">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header email-detail-head">
                                <div class="user-details d-flex justify-content-between align-items-center flex-wrap">
                                    <div class="avatar mr-75">
                                        <img
                                            :src="baseUrl + '/images/logo/logo1.jpg'"
                                            alt="avatar img holder"
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                    <div class="mail-items">
                                        <div class="email-info-dropup dropdown">
                                            <span
                                                role="button"
                                                class="dropdown-toggle font-small-3 text-muted"
                                                id="card_top01"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                {{ getActiveEmail.to[0].email }}
                                            </span>
                                            <div class="dropdown-menu" aria-labelledby="card_top01">
                                                <table class="table table-sm table-borderless">
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-right">From:</td>
                                                            <td>{{ getActiveEmail.from_name }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">To:</td>
                                                            <td>
                                                                <template v-for="(toEmail, index) in getActiveEmail.to">
                                                                    <template if="index != 0">,</template>
                                                                    {{ toEmail.email }}
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="getActiveEmail.cc != null && getActiveEmail.cc.length > 0">
                                                            <td class="text-right">CC:</td>
                                                            <td>
                                                                <template v-for="(ccEmail, index) in getActiveEmail.cc">
                                                                    <template if="index != 0">,</template>
                                                                    {{ ccEmail.email }}
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="getActiveEmail.bcc != null && getActiveEmail.bcc.length > 0">
                                                            <td class="text-right">BCC:</td>
                                                            <td>
                                                                <template v-for="(bccEmail, index) in getActiveEmail.bcc">
                                                                    <template if="index != 0">,</template>
                                                                    {{ bccEmail.email }}
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">Date:</td>
                                                            <td>{{ moment.unix(getActiveEmail.date_added).format('lll') }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mail-meta-item d-flex align-items-center">
                                    <small class="mail-date-time text-muted">
                                        {{ moment.unix(getActiveEmail.date_added).format('lll') }}
                                    </small>
                                </div>
                            </div>
                            <div class="card-body mail-message-wrapper pt-2">
                                <div class="mail-message">
                                    <p class="card-text">
                                        <span class="text-primary">
                                            Message:
                                        </span>
                                        {{ getActiveEmail.body }}
                                    </p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="mail-attachments">
                                    <div class="d-flex align-items-center mb-1">
                                        <vue-feather type="paperclip" size="1.1rem" class="mr-50"></vue-feather>
                                        <h5 class="font-weight-bolder text-body mb-0">
                                            {{ getActiveEmail._attachments.length }} Attachments
                                        </h5>
                                    </div>
                                    <div vif="getActiveEmail._attachments.length > 0" class="d-flex flex-column">
                                        <a v-for="attachment in getActiveEmail._attachments" :href="attachment._attachment_file_url" target="_blank" class="mb-50">
                                            <img
                                                :src="attachment.content_type.includes('application') ? (baseUrl + '/images/icons/doc.png') : (baseUrl + '/images/icons/jpg.png')"
                                                class="mr-25 image-small"
                                                :alt="attachment.filename"
                                                height="18"
                                            />
                                            <small class="text-muted font-weight-bolder">
                                                {{ attachment.file_name }}
                                            </small>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <email  v-bind:have-letter="false"/>
</template>
<style>
</style>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import { useClicksendStore } from '../../stores/ClicksendStore.js'
    import moment from 'moment';
    export default {
        mounted() {
            this.clicksendStore.fetchEmailHistory();
        },
        components: {
        },
        setup(props) {
            return {
                baseUrl: baseUrl,
                settingStore: useSettingStore(),
                clicksendStore: useClicksendStore(),
                showDetail: ref(false),
                activeEmailID: ref(null),
                moment: moment,
                counter: ref(0),
                localizationStore: useLocalizationStore()
            }
        },
        watch: {
        },
        methods: {
            showDetailedEmail(index)
            {
                this.showDetail = !this.showDetail;
                this.activeEmailID = index;
                setTimeout(() => {
                    const ps = new PerfectScrollbar('.email-app-details');
                }, "1000")
            },
            exportEmails()
            {
                let $this = this,
                url = $this.settingStore.getUrl('/email/history/export');
                if (!$this.clicksendStore.isCredentialValid) {
                    toastr.error(
                        $this.localizationStore.translate("clicksend.credentials.wrong.error.message"),
                        'Error!'
                    );
                    return;
                }
                axios.get(
                    url,
                    {
                         auth: {
                            username: $this.settingStore.clicksend.clicksend_username,
                            password: $this.settingStore.clicksend.clicksend_password
                        }
                    },
                ).then(function(response) {
                    window.location.href = response.data.data.url;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            }
        },
        computed: {
            getActiveEmail() {
                return this.clicksendStore.emailHistoryList.data[this.activeEmailID];
            }
        },
        directives: {
            forCallback(el, binding) {
                if (binding.value.index == (binding.value.length - 1)) {
                    setTimeout(() => {
                        const emailUserList = new PerfectScrollbar('.email-user-list');
                    }, "1000")
                }
            }
        }
    }
</script>
